/* e*thirteen blog — article page behavior (loaded by
   sections/main-article-modern.liquid, defer).
   Jump nav (TOC) built from body headings, scrollspy, sticky mobile
   "On this page" bar, copy-link button. */
(function () {
  'use strict';

  var article = document.querySelector('[data-eblog-article]');
  if (!article) return;

  var body = article.querySelector('.eblog-body');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Sticky offset — measure the (sticky) site header so the TOC, sticky
     sidebar, and scroll-margins all clear it.
     ------------------------------------------------------------------ */
  var offsetPx = 96; // keep in sync with the --eblog-offset fallback in eblog.css

  // Breathing room left between a break-out stage and the promo rail.
  var STAGE_RAIL_GAP = 32;

  function setOffset() {
    var header = document.querySelector('.section-header');
    if (header) offsetPx = header.offsetHeight;
    article.style.setProperty('--eblog-offset', offsetPx + 'px');

    // full-bleed gallery breakout: distance from the viewport's left edge
    // to the article column, and the scrollbar-free viewport width
    if (body) {
      var rect = body.getBoundingClientRect();
      article.style.setProperty('--eblog-bleed-left', Math.round(rect.left) + 'px');
      article.style.setProperty('--eblog-vw', document.documentElement.clientWidth + 'px');

      // Break-out media (shoppable image, a row of Instagram embeds) is laid
      // out against the layout box rather than the reading column.
      var layout = article.querySelector('.eblog-layout');
      if (layout) {
        var lr = layout.getBoundingClientRect();
        // Break-out media is centered on the reading column, so the widest
        // it can be is twice its shortest run to an obstacle: the layout's
        // left edge on one side, and either the promo rail or the layout's
        // right edge on the other. Taking the smaller of the two keeps the
        // stage symmetric about the text and off the rail's cards, which it
        // would otherwise paint over (opaque background, z-index 1).
        var mid = rect.left + rect.width / 2;
        var right = lr.right;
        var promo = layout.querySelector('.eblog-rail--promo');
        if (promo) {
          var prr = promo.getBoundingClientRect();
          if (prr.width > 0) right = prr.left - STAGE_RAIL_GAP;
        }
        var stage = 2 * Math.max(0, Math.min(mid - lr.left, right - mid));
        article.style.setProperty('--eblog-stage-width', Math.round(stage) + 'px');
      }
    }
  }
  setOffset();
  // resize handling is consolidated into one debounced handler at the bottom,
  // using the theme's global debounce from global.js

  /* ------------------------------------------------------------------
     Wide tables from legacy content scroll inside their own box
     ------------------------------------------------------------------ */
  if (body) {
    body.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement.classList.contains('eblog-body__table-scroller')) return;
      var wrap = document.createElement('div');
      wrap.className = 'eblog-body__table-scroller';
      /* A spec table with this many columns cannot be set in the reading
         column without the cells collapsing to one word a line, so it breaks
         out onto the same stage the galleries use. Narrower tables stay in
         the column, where a full-width box would leave them looking sparse. */
      var head = table.querySelector('tr');
      if (head && head.cells.length >= 5) wrap.classList.add('eblog-body__table-scroller--wide');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  var mobileBar = article.querySelector('[data-eblog-mobilenav]');
  var mobileToggle = article.querySelector('[data-eblog-mobile-toggle]');
  var mobileCurrent = article.querySelector('[data-eblog-mobile-current]');

  /* ------------------------------------------------------------------
     Jump nav — collect headings, take the two shallowest levels present
     (legacy posts use h4/h5 where new ones use h2/h3), slugify ids,
     render into the desktop panel and the mobile dropdown.
     ------------------------------------------------------------------ */
  var headings = [];
  if (body) {
    var all = Array.prototype.slice.call(body.querySelectorAll('h2, h3, h4, h5')).filter(function (h) {
      // spliced media components carry their own headings (product cards,
      // gallery captions) that are chrome, not story structure
      return !h.closest('.eblog-shoppable, .eblog-gallery');
    });
    var levels = all
      .map(function (h) { return parseInt(h.tagName.charAt(1), 10); })
      .filter(function (v, i, a) { return a.indexOf(v) === i; })
      .sort();
    var keep = levels.slice(0, 2);
    headings = all.filter(function (h) {
      return keep.indexOf(parseInt(h.tagName.charAt(1), 10)) !== -1 && h.textContent.trim();
    });

    var seen = {};
    headings.forEach(function (h) {
      if (h.id) return;
      var slug = h.textContent.trim().toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .slice(0, 60) || 'section';
      if (seen[slug]) slug += '-' + (++seen[slug]);
      else seen[slug] = 1;
      h.id = slug;
    });

    var topLevel = keep[0];
    var links = [];

    function buildList(target) {
      var ul = document.createElement('ul');
      ul.className = 'eblog-toc__list';
      headings.forEach(function (h) {
        var li = document.createElement('li');
        li.dataset.depth = parseInt(h.tagName.charAt(1), 10) === topLevel ? '1' : '2';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          history.pushState(null, '', '#' + h.id);
          pinActive(h);
          h.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          closeMobile();
        });
        li.appendChild(a);
        ul.appendChild(li);
        links.push(a);
      });
      target.appendChild(ul);
    }

    var mainCount = headings.filter(function (h) {
      return parseInt(h.tagName.charAt(1), 10) === topLevel;
    }).length;

    // Show the jump nav for any post with more than one section. A single
    // heading indexes nothing, so that case still hides it.
    if (mainCount >= 2) {
      var tocPanel = article.querySelector('[data-eblog-toc]');
      var mobilePanel = article.querySelector('[data-eblog-mobile-panel]');
      if (tocPanel) {
        buildList(tocPanel);
        tocPanel.closest('.eblog-toc').classList.add('is-ready');
      }
      if (mobilePanel) {
        buildList(mobilePanel);
        mobileBar && mobileBar.classList.add('is-ready');
      }
    }
  }

  /* ------------------------------------------------------------------
     Sticky mobile bar
     ------------------------------------------------------------------ */
  function closeMobile() {
    if (!mobileBar) return;
    mobileBar.classList.remove('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileBar.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobile();
    });
  }

  /* ------------------------------------------------------------------
     Scrollspy — one rAF-throttled scroll handler
     ------------------------------------------------------------------ */
  var tocLinks = article.querySelectorAll('.eblog-toc__list a');
  var activeId = null;
  var ticking = false;

  // Scrollspy compares against cached document-space heading positions, so
  // the per-frame update does no layout reads at all.
  var headingTops = [];

  // An anchor jump parks a heading at its own scroll-margin-top, so that is
  // exactly where the spy's threshold has to sit. Reading it from the
  // heading keeps the two from drifting apart (the CSS value is derived
  // from --eblog-offset, which JS also writes), and the small pad absorbs
  // the pixel or two a smooth scroll lands off by. Without the pad a click
  // parks the heading just above the line and the PREVIOUS section stays lit.
  var spyPad = offsetPx + 24;

  function cacheHeadingTops() {
    if (headings.length) {
      var sm = parseFloat(getComputedStyle(headings[0]).scrollMarginTop);
      if (!isNaN(sm)) spyPad = sm + 12;
    }
    headingTops = headings.map(function (h) {
      return h.getBoundingClientRect().top + window.scrollY;
    });
  }
  cacheHeadingTops();

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function applyActive(current) {
    var id = current ? current.id : null;
    if (id === activeId) return;
    activeId = id;
    tocLinks.forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
    });
    if (mobileCurrent) {
      mobileCurrent.textContent = current ? current.textContent.trim() : '';
    }
  }

  /* Clicking a jump-nav link is an explicit choice, so it holds until the
     scroll settles. The spy alone is not enough here: an image finishing
     load above the target shifts it down past the threshold mid-flight,
     and the reader watches the section they did NOT click light up. */
  var pinned = null;
  var pinTimer = null;

  function pinActive(h) {
    pinned = h;
    applyActive(h);
    clearTimeout(pinTimer);
    pinTimer = setTimeout(unpin, 1200);
  }

  function unpin() {
    if (!pinned) return;
    pinned = null;
    clearTimeout(pinTimer);
    cacheHeadingTops(); // the scroll may have shifted things under us
    update();
  }

  function update() {
    ticking = false;
    if (!body || !headings.length || pinned) return;

    var threshold = window.scrollY + spyPad;
    var current = null;
    for (var i = 0; i < headings.length; i++) {
      if (headingTops[i] <= threshold) current = headings[i];
      else break;
    }
    applyActive(current);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if ('onscrollend' in window) window.addEventListener('scrollend', unpin);

  /* Lazy images resolving above the reader are what move a heading out from
     under the spy's threshold. Recache whenever the body's height changes
     rather than trusting the one-shot measurement taken at build time. */
  if (window.ResizeObserver) {
    new ResizeObserver(
      debounce(function () {
        cacheHeadingTops();
        update();
      }, 120)
    ).observe(body);
  }

  update();

  /* ------------------------------------------------------------------
     Promo rail vs full-bleed galleries: the gallery paints over the rail
     column, so any rail item sharing a gallery's vertical band would be
     hidden. Flow rail items around the bands instead - items above a
     gallery stay put, the next item resumes below it.
     ------------------------------------------------------------------ */
  function avoidGalleries() {
    var inner = article.querySelector('.eblog-rail--promo .eblog-rail__inner');
    if (!inner) return;
    var kids = Array.prototype.slice.call(inner.children);
    kids.forEach(function (c) { c.style.marginTop = ''; });

    var bands = Array.prototype.map.call(article.querySelectorAll('.eblog-gallery'), function (g) {
      var r = g.getBoundingClientRect();
      return { top: r.top + window.scrollY - 24, bottom: r.bottom + window.scrollY + 24 };
    });
    if (!bands.length || window.innerWidth < 990) return;

    // Read every rect once, then compute the pushes arithmetically (adding
    // margin to one item shifts every later item by the same delta), and
    // write all margins in one pass - no interleaved read/write reflows.
    var rects = kids.map(function (c) {
      var r = c.getBoundingClientRect();
      return { top: r.top + window.scrollY, bottom: r.bottom + window.scrollY };
    });
    var shift = 0;
    kids.forEach(function (c, k) {
      var top = rects[k].top + shift;
      var bottom = rects[k].bottom + shift;
      var push = 0;
      for (var i = 0; i < bands.length; i++) {
        if (top < bands[i].bottom && bottom > bands[i].top) {
          var d = Math.round(bands[i].bottom - top);
          push += d;
          top += d;
          bottom += d;
        }
      }
      if (push) {
        c.style.marginTop = push + 'px';
        shift += push;
      }
    });
  }

  avoidGalleries();

  /* ------------------------------------------------------------------
     One resize/load pipeline: offset first, then the cached positions
     that depend on it, so nothing reads a stale measurement.
     ------------------------------------------------------------------ */
  function remeasure() {
    setOffset();
    cacheHeadingTops();
    avoidGalleries();
    update();
  }
  window.addEventListener('resize', debounce(remeasure, 150));
  window.addEventListener('load', remeasure);

  /* ------------------------------------------------------------------
     Galleries — arrow scrolling, edge-aware arrow visibility
     ------------------------------------------------------------------ */
  article.querySelectorAll('[data-eblog-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-eblog-gallery-track]');
    var prev = gallery.querySelector('[data-eblog-gallery-prev]');
    var next = gallery.querySelector('[data-eblog-gallery-next]');
    if (!track) return;

    /* Page by PHOTO, not by a fraction of the track. Photos are height
       capped with the width following each one's aspect, so they are all
       different widths, and the old fixed 80%-of-the-track jump landed
       between two of them - whereupon `scroll-snap-align: center` pulled the
       track on to the NEXT one and the arrows appeared to skip an image.
       Move one photo at a time, and land on the snap position itself so the
       browser has nothing left to correct. */
    function centered(items, box) {
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function page(dir) {
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      var box = track.getBoundingClientRect();
      var next = items[centered(items, box) + dir];
      if (!next) return;
      var r = next.getBoundingClientRect();
      track.scrollBy({
        left: r.left + r.width / 2 - (box.left + box.width / 2),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    /* Read the edges off the first and last photo, not off scrollLeft.
       The track snaps items to CENTER inside 5vw of padding, so its resting
       start position is a few pixels in from zero and `scrollLeft === 0`
       never happens - which left the back arrow showing on a gallery that
       could not go back. A photo sitting fully inside the track means there
       is nothing further that way, whatever the scroll numbers say. */
    function edges() {
      var items = track.children;
      if (!items.length) return;
      var box = track.getBoundingClientRect();
      var first = items[0].getBoundingClientRect();
      var last = items[items.length - 1].getBoundingClientRect();
      if (prev) prev.hidden = first.left >= box.left - 8;
      if (next) next.hidden = last.right <= box.right + 8;
    }

    /* Every photo ships `loading="lazy"`, which is right while the gallery
       is far down the page and wrong once the reader has arrived at it: only
       the frames already on screen count as visible, so arrowing along the
       track can land on a photo that has not started loading and reads as a
       broken image. Promote the whole track the moment the gallery nears the
       viewport, so the fetches are already in flight by the time it is used. */
    function loadAll() {
      Array.prototype.forEach.call(track.querySelectorAll('img[loading="lazy"]'), function (img) {
        img.loading = 'eager';
      });
    }

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          loadAll();
        },
        { rootMargin: '600px 0px' }
      );
      io.observe(gallery);
    } else {
      loadAll();
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    var edgeTick = false;
    track.addEventListener(
      'scroll',
      function () {
        if (edgeTick) return;
        edgeTick = true;
        requestAnimationFrame(function () {
          edgeTick = false;
          edges();
        });
      },
      { passive: true }
    );

    // The first measurement happens before the photos have their intrinsic
    // size, when scrollWidth still equals clientWidth. Re-run as the track
    // grows, or both arrows stay hidden until the reader scrolls it.
    if (window.ResizeObserver) new ResizeObserver(edges).observe(track);
    window.addEventListener('load', edges);
    edges();
  });

  /* ------------------------------------------------------------------
     Shoppable images — hotspot popovers + coordinate debug mode
     ------------------------------------------------------------------ */
  var openPop = null;

  function closePop() {
    if (!openPop) return;
    openPop.pop.hidden = true;
    openPop.dot.setAttribute('aria-expanded', 'false');
    openPop = null;
  }

  article.querySelectorAll('[data-eblog-hotspot]').forEach(function (dot) {
    var pop = dot.parentElement.querySelector('[data-eblog-hotspot-pop]');
    if (!pop) return;
    dot.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = openPop && openPop.dot === dot;
      closePop();
      if (!isOpen) {
        pop.hidden = false;
        dot.setAttribute('aria-expanded', 'true');
        openPop = { dot: dot, pop: pop };
      }
    });
  });

  if (article.querySelector('[data-eblog-hotspot]')) {
    document.addEventListener('click', function (e) {
      if (openPop && !openPop.pop.contains(e.target)) closePop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePop();
    });
  }

  /* ------------------------------------------------------------------
     Hotspot builder (?debug=true)
     An editor builds the dots on the photo itself: click to place one,
     search a product for it, name it, drag it into place, and copy the
     finished lines into the post's "Shoppable hotspots" metafield. The
     lines are the only stored form, so the builder loads them from the
     rendered figure and writes them back as text. Nothing here talks to
     the admin; product search is the storefront's own predictive search.
     ------------------------------------------------------------------ */
  /* ?debug=true opens it; the older ?hotspots=debug still works. */
  if (/[?&](debug=true|hotspots=debug)(&|$)/.test(window.location.search)) {
    article.querySelectorAll('[data-eblog-shoppable]').forEach(function (fig) {
      var stage = fig.querySelector('[data-eblog-shoppable-stage]');
      if (!stage) return;
      fig.classList.add('eblog-shoppable--debug');

      /* State comes from the rendered dots, broken ones included. */
      var dots = [];
      fig.querySelectorAll('.eblog-hotspot').forEach(function (el) {
        dots.push({
          x: parseFloat(el.style.left) || 0,
          y: parseFloat(el.style.top) || 0,
          handle: el.dataset.eblogHotspotHandle || '',
          title: el.dataset.eblogHotspotTitle || '',
          broken: el.classList.contains('eblog-hotspot--broken')
        });
        el.remove();
      });

      var panel = document.createElement('aside');
      panel.className = 'eblog-hsb';
      panel.innerHTML =
        '<div class="eblog-hsb__head"><span class="eblog-panel__label">Hotspot builder</span>' +
        '<span class="eblog-hsb__count" data-hsb-count></span></div>' +
        '<div class="eblog-hsb__row"><button type="button" class="eblog-hsb__btn" data-hsb-copy>Copy hotspots</button>' +
        '<span class="eblog-hsb__note" data-hsb-note></span></div>' +
        '<p class="eblog-hsb__help">Click the photo to add a dot. Click a dot to change its product. Drag to move. ' +
        'Copy, then paste into the post’s <strong>Shoppable hotspots</strong> field.</p>' +
        '<textarea class="eblog-hsb__out" data-hsb-out readonly rows="5" spellcheck="false"></textarea>';
      document.body.appendChild(panel);
      var out = panel.querySelector('[data-hsb-out]');
      var note = panel.querySelector('[data-hsb-note]');
      var count = panel.querySelector('[data-hsb-count]');

      function fmt(n) { return (Math.round(n * 10) / 10).toString(); }
      function lines() {
        return dots.map(function (d) { return fmt(d.x) + ' | ' + fmt(d.y) + ' | ' + d.handle; });
      }
      function say(msg) { note.textContent = msg; setTimeout(function () { if (note.textContent === msg) note.textContent = ''; }, 2500); }

      panel.querySelector('[data-hsb-copy]').addEventListener('click', function () {
        var text = lines().join('\n');
        if (navigator.clipboard) navigator.clipboard.writeText(text).then(function () { say('Copied ' + dots.length + ' line' + (dots.length === 1 ? '' : 's')); });
        else { out.select(); say('Select the text and copy it'); }
      });

      var editor = null;
      function closeEditor() { if (editor) { editor.remove(); editor = null; } }

      function render() {
        stage.querySelectorAll('.eblog-hotspot--edit').forEach(function (el) { el.remove(); });
        dots.forEach(function (d, i) {
          var el = document.createElement('div');
          el.className = 'eblog-hotspot eblog-hotspot--edit' + (d.broken || !d.handle ? ' eblog-hotspot--broken-edit' : '');
          el.style.left = d.x + '%';
          el.style.top = d.y + '%';
          el.innerHTML = '<button type="button" class="eblog-hotspot__dot" aria-label="Edit hotspot"></button>' +
            '<span class="eblog-hsb__tag">' + (d.title || (d.handle ? d.handle : 'no product')) + (d.broken ? ' · not found' : '') + '</span>';
          var moved = false, drag = null;
          var btn = el.querySelector('button');
          btn.addEventListener('pointerdown', function (e) {
            drag = { id: e.pointerId }; moved = false; btn.setPointerCapture(e.pointerId); e.preventDefault();
          });
          btn.addEventListener('pointermove', function (e) {
            if (!drag) return;
            var r = stage.getBoundingClientRect();
            var nx = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
            var ny = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
            if (Math.abs(nx - d.x) > 0.3 || Math.abs(ny - d.y) > 0.3) moved = true;
            if (moved) { d.x = nx; d.y = ny; el.style.left = nx + '%'; el.style.top = ny + '%'; sync(false); }
          });
          btn.addEventListener('pointerup', function (e) {
            if (!drag) return;
            drag = null; btn.releasePointerCapture(e.pointerId);
            if (moved) { sync(); return; }
            openEditor(i, el);
          });
          btn.addEventListener('click', function (e) { e.stopPropagation(); });
          stage.appendChild(el);
        });
        sync();
      }

      function sync(full) {
        out.value = lines().join('\n');
        count.textContent = dots.length + (dots.length === 1 ? ' dot' : ' dots');
        if (full !== false && editor) editor.style.left = dots[editor.dataset.index].x + '%';
      }

      function openEditor(i, anchor) {
        closeEditor();
        var d = dots[i];
        editor = document.createElement('div');
        editor.className = 'eblog-hsb__editor' + (d.x > 55 ? ' is-left' : '') + (d.y > 70 ? ' is-up' : '');
        editor.dataset.index = i;
        editor.style.left = d.x + '%';
        editor.style.top = d.y + '%';
        editor.innerHTML =
          '<label class="eblog-hsb__field"><span>Product</span><input type="search" data-hsb-q placeholder="Search products" autocomplete="off"></label>' +
          '<div class="eblog-hsb__current" data-hsb-current></div>' +
          '<ul class="eblog-hsb__results" data-hsb-results hidden></ul>' +
          '<div class="eblog-hsb__row"><button type="button" class="eblog-hsb__btn" data-hsb-done>Done</button>' +
          '<button type="button" class="eblog-hsb__btn eblog-hsb__btn--quiet" data-hsb-delete>Delete</button></div>';
        stage.appendChild(editor);
        var q = editor.querySelector('[data-hsb-q]');
        var res = editor.querySelector('[data-hsb-results]');
        var cur = editor.querySelector('[data-hsb-current]');
        function showCurrent() {
          cur.textContent = d.handle ? (d.broken ? 'Not found: ' + d.handle : (d.title || d.handle)) : 'No product yet';
          cur.classList.toggle('is-bad', !!(d.broken || !d.handle));
        }
        showCurrent();
        var timer = null;
        q.addEventListener('input', function () {
          clearTimeout(timer);
          var term = q.value.trim();
          if (term.length < 2) { res.hidden = true; return; }
          timer = setTimeout(function () {
            fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (j) {
                var items = (j.resources && j.resources.results && j.resources.results.products) || [];
                res.innerHTML = items.length ? '' : '<li class="eblog-hsb__empty">No products match</li>';
                items.forEach(function (p) {
                  var li = document.createElement('li');
                  li.innerHTML = (p.image ? '<img src="' + p.image + '" alt="">' : '') + '<span>' + p.title + '</span>';
                  li.addEventListener('click', function () {
                    d.handle = p.handle; d.title = p.title; d.broken = false;
                    closeEditor(); render();
                  });
                  res.appendChild(li);
                });
                res.hidden = false;
              })
              .catch(function () { res.innerHTML = '<li class="eblog-hsb__empty">Search failed</li>'; res.hidden = false; });
          }, 200);
        });
        editor.querySelector('[data-hsb-done]').addEventListener('click', function () { closeEditor(); render(); });
        editor.querySelector('[data-hsb-delete]').addEventListener('click', function () { dots.splice(i, 1); closeEditor(); render(); });
        editor.addEventListener('click', function (e) { e.stopPropagation(); });
        editor.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeEditor(); render(); } });
        q.focus();
      }

      stage.addEventListener('click', function (e) {
        if (e.target.closest('.eblog-hotspot, .eblog-hsb__editor')) return;
        if (editor) { closeEditor(); render(); return; }
        var r = stage.getBoundingClientRect();
        var x = Math.round(((e.clientX - r.left) / r.width) * 1000) / 10;
        var y = Math.round(((e.clientY - r.top) / r.height) * 1000) / 10;
        dots.push({ x: x, y: y, handle: '', title: '', broken: false });
        render();
        openEditor(dots.length - 1, stage.lastElementChild);
      });

      render();
    });
  }

  /* ------------------------------------------------------------------
     Copy link
     ------------------------------------------------------------------ */
  var copyBtn = article.querySelector('[data-eblog-copy]');
  var copiedNote = article.querySelector('[data-eblog-copied]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(copyBtn.dataset.url || window.location.href).then(function () {
        if (!copiedNote) return;
        copiedNote.classList.add('is-visible');
        setTimeout(function () { copiedNote.classList.remove('is-visible'); }, 2000);
      });
    });
  }

  /* Native share sheet. Where the browser has one it is a better answer than
     any list of networks we could pick: the reader gets whatever they
     actually use, WhatsApp and Messages and Instagram DM included. It only
     appears once we know it works, so a browser without it keeps the
     explicit buttons. */
  var nativeBtn = article.querySelector('[data-eblog-native-share]');
  var shareRow = article.querySelector('[data-eblog-share-row]');
  if (nativeBtn && navigator.share) {
    nativeBtn.hidden = false;
    if (shareRow) shareRow.classList.add('eblog-share--native');
    nativeBtn.addEventListener('click', function () {
      navigator
        .share({
          title: nativeBtn.dataset.title || document.title,
          url: nativeBtn.dataset.url || window.location.href
        })
        .catch(function () {
          /* the reader dismissed the sheet, which is not an error */
        });
    });
  }
})();
